/*eslint-disable */
import { createApp } from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import locale from 'element-plus/lib/locale/lang/zh-cn'
import '@/projects/tech-blue/assets/css/page.css';
import bus from '@/components/common/bus';
import mixins from "@/mixins";
import directives from '@/directives';
import constants from "@/api/constants";
import XEUtils from 'xe-utils';
import '@/mixins/XEUtilsMixin';
import autoRegComponents from '@components/index';
import '@components/SvgIcon/index.js';
import SvgIcon from '@components/SvgIcon/index.vue';

import 'font-awesome/scss/font-awesome.scss';

import MetaInfo from 'vue-meta-info';
import utils from "@/utils/utils";

const rewriteNext = (to, next) => {
	if (utils.isNotEmpty(to.query.code) && utils.isNotEmpty(to.query.state)) {
		let nextTo = { ...to };
		delete nextTo.query.code;
		delete nextTo.query.state;
		next(nextTo);
		return;
	}
	if (utils.isNotEmpty(to.query.xcx_code)) {
		let nextTo = { ...to };
		delete nextTo.query.xcx_code;
		next(nextTo);
		return;
	}
	next();
};

const setTitle = (setting, to) => {
	let title = `${ setting.cms_website_name || process.env.VUE_APP_TITLE }`;
	if (to.path.indexOf('/page') === 0 && store.state.currColumn) {
		if (utils.isNotEmpty(store.state.currColumn.name)) {
			title = store.state.currColumn.name;
		}
	}
	document.title = title;
};

router.beforeEach((to, from, next) => {
	if (utils.isNotEmpty(to.query.account)) {
		window.configs.PROJECT_ACCOUNT = to.query.account;
	}
	if (utils.isNotEmpty(to.query.code) && utils.isNotEmpty(to.query.state)) {
		window.configs.wx_login_code = to.query.code;
	}
	if (utils.isNotEmpty(to.query.xcx_code)) {
		window.configs.xcx_login_code = to.query.xcx_code;
	}
	let setting = store.state.setting;
	if (setting) {
		setTitle(setting, to);
		rewriteNext(to, next);
	} else {
		store.dispatch('initCmsSetting').then(setting => {
			setTitle(setting, to);
			rewriteNext(to, next);
		}).catch(() => {
			document.title = `${ process.env.VUE_APP_TITLE }`;
			rewriteNext(to, next);
		});
	}
});

const app = createApp(App);
app.config.globalProperties.$bus = bus;
app.config.globalProperties.$api = constants;
app.config.globalProperties.$XEUtils = XEUtils;
app.config.globalProperties.$utils = utils;
app.mixin(mixins);
// 自动注册指令
app.use(directives);
// 自动注册基础组件
app.use(autoRegComponents);
app.component('SvgIcon', SvgIcon);
app.use(ElementPlus, {
	size: 'small',
	locale,
});
// SEO
app.use(MetaInfo);
app.use(router).use(store).mount("#app");
